import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageSubheader } from '../../../../shared/ui/page-subheader/PageSubheader';
import { TabSwitcher } from '../../../../shared/ui/tab-switcher/TabSwitcher';
import {
  selectTemplatesActiveTab,
  templatesChannelTabChanged,
} from '../../../../features/templates/store/templatesSlice';
import styles from './TemplatesSubheader.module.css';
import { TEMPLATE_TABS } from './lib/templatesChannelTabs';

export function TemplatesSubheader() {
  const dispatch = useDispatch();
  const activeTab = useSelector(selectTemplatesActiveTab);

  const onTabClick = useCallback(
    (tabKey) => {
      dispatch(templatesChannelTabChanged(tabKey));
    },
    [dispatch],
  );

  const items = useMemo(
    () =>
      TEMPLATE_TABS.map((tab) => ({
        key: tab.key,
        label: tab.label,
        isActive: tab.key === activeTab,
        onClick: () => onTabClick(tab.key),
      })),
    [activeTab, onTabClick],
  );

  return (
    <PageSubheader
      title="Templates"
      right={
        <div className={clsx(styles.tabs)}>
          <TabSwitcher items={items} ariaLabel="Templates type" />
        </div>
      }
    />
  );
}
